import utils from 'utils';
class financialListCtrl {
    constructor(
        $scope,
        sweetalert,
        $state,
        httpRequest,
        logger,
        $uibModal,
        initSortService,
        Upload,
        $timeout
    ) {
        const currentTaxPeriod = getAccountPeriod().replace(/-/, ''); //当前会计期间
        $scope.isCurrentPeriod = true; //属期是否为当前所属期
        $scope.isCollapsed = false;
        $scope.dic = {}; //数据字典
        $scope.financialList = [];
        $scope.totalItems = 0;
        $scope.voucherStatistical = {};
        $scope.copeyVoucherStatistical = {};
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                accountDateBegin: '',
                accountDateEnd: '',
                contractType: '',
                accountStatus: '',
                subjectName: '',
                voucherAbstract: '',
                voucherCode: '',
                taxPeriod: currentTaxPeriod,
            },
        };
        $scope.reset = function reset() {
            let taxPeriod = $scope.queryParam.param.taxPeriod;
            $scope.queryParam.param = {
                accountDateBegin: '',
                accountDateEnd: '',
                contractType: '',
                accountStatus: '',
                subjectName: '',
                voucherAbstract: '',
                voucherCode: '',
                taxPeriod,
            };
        };
        // 选中信息
        $scope.selectedRows = [];
        //列表查询
        $scope.queryList = function queryList(needCheck) {
            $scope.queryParam = sessionStorage.financialCounttingParam
                ? JSON.parse(sessionStorage.financialCounttingParam)
                : $scope.queryParam;
            if (needCheck) {
                $scope.queryParam.param.taxPeriod = currentTaxPeriod;
                $scope.queryParam.pageNum = 1;
                $scope.reset();
                $scope.searchList();
                return;
            }
            $scope.queryParam.param.taxPeriod = $scope.queryParam.param.taxPeriod.replace(/-/g, '');
            httpRequest.post_qryByPage($scope.queryParam).then(res => {
                $scope.financialList = res.data.value.list;
                $scope.totalItems = res.data.value.total;
                $scope.queryParam.pageNum = res.data.value.pageNum;
                $scope.selectedRows = [];
            });
            getVoucherStatistical();
        };

        //搜索
        $scope.searchList = function () {
            sessionStorage.setItem('financialCounttingParam', JSON.stringify($scope.queryParam));
            $scope.queryList();
        };

        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                'financialCounttingParam',
                JSON.stringify({
                    pageNum: $scope.queryParam.pageNum,
                    pageSize: $scope.queryParam.pageSize,
                    param: sessionStorage.financialCounttingParam
                        ? JSON.parse(sessionStorage.financialCounttingParam).param
                        : {
                              accountDateBegin: '',
                              accountDateEnd: '',
                              contractType: '',
                              accountStatus: '',
                              subjectName: '',
                              voucherAbstract: '',
                              voucherCode: '',
                              taxPeriod: $scope.queryParam.param.taxPeriod,
                          },
                })
            );
            $scope.queryList();
        };

        //获取分页数据统计
        async function getVoucherStatistical() {
            let res = await httpRequest.post_voucherStatistical($scope.queryParam);
            $scope.voucherStatistical.creditAmtCount = fixNumber(res.data.value.creditAmtCount);
            $scope.voucherStatistical.debitAmtCount = fixNumber(res.data.value.debitAmtCount);
            $scope.voucherStatistical.voucherNumber = res.data.value.voucherNumber;
            $scope.copeyVoucherStatistical = JSON.parse(JSON.stringify($scope.voucherStatistical));
        }

        $scope.orderMap = initSortService('financialCounttingParam');
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey) {
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
            }
            sessionStorage.setItem('financialCounttingParam', JSON.stringify($scope.queryParam));
            $scope.queryList();
        };

        // 初始化查询和表格控件实例
        $scope.customizedConfig = {
            version: 1.0,
            table: [
                {
                    label: '记账日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '凭证号',
                    selected: true,
                    default: true,
                },
                {
                    label: '摘要',
                    selected: true,
                    default: true,
                },
                {
                    label: '科目编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '科目名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '借方金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '贷方金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '对账状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '来源',
                    selected: true,
                    default: true,
                },
                {
                    label: '人员/时间',
                    selected: true,
                    default: true,
                },
            ],
        };
        $scope.tableDropdownConfig = [
            {
                label: '不对帐',
                handler(item) {
                    sweetalert
                        .confirm('提醒', '确认不对账？确定后该数据不进入对账台账！')
                        .then(() => {
                            httpRequest
                                .get_accountOpt({ voucherId: item.voucherId, optEnum: 2 })
                                .then(res => {
                                    if (res.data.value < 0) {
                                        logger.logSuccess(
                                            '已确认对账相符，修改后请进入财税对账台账中重新对账！'
                                        );
                                    } else {
                                        logger.logSuccess('操作成功');
                                    }
                                    $scope.queryList();
                                });
                        });
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('check_account') &&
                        item.accountStatus != -1 &&
                        $scope.isCurrentPeriod
                    );
                },
            },
            {
                label: '对帐',
                handler(item) {
                    sweetalert
                        .confirm(
                            '提醒',
                            '确定修改为对账数据？确定后该数据将进入对账台账，请重新对账！'
                        )
                        .then(() => {
                            httpRequest
                                .get_accountOpt({ voucherId: item.voucherId, optEnum: 1 })
                                .then(res => {
                                    if (res.data.value < 0) {
                                        logger.logSuccess(
                                            '已确认对账相符，修改后请进入财税对账台账中重新对账！'
                                        );
                                    } else {
                                        logger.logSuccess('操作成功');
                                    }
                                    $scope.queryList();
                                });
                        });
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('check_account') &&
                        item.accountStatus == -1 &&
                        $scope.isCurrentPeriod
                    );
                },
            },
            {
                label: '删除',
                handler(item) {
                    $scope.batchDelete([item]);
                },
                showWhile(item, hasPermit) {
                    return (
                        hasPermit('delete_financial') &&
                        (item.accountStatus == -1 || item.accountStatus == 0) &&
                        $scope.isCurrentPeriod
                    );
                },
            },
        ];
        // 批量删除
        $scope.batchDelete = function (item) {
            if (!$scope.isCurrentPeriod) return;
            const selectedRows = item || $scope.selectedRows;
            if (!selectedRows.length) {
                return logger.logError('请选择要删除的数据行');
            }
            const voucherIdList = [];
            let haveIllegal = false;
            selectedRows.forEach(row => {
                voucherIdList.push(row.voucherId);
                if (row.accountStatus == 1 || row.accountStatus == 2) haveIllegal = true;
            });
            if (haveIllegal) {
                return logger.logError('不允许删除已对账的数据，请修改！');
            }
            sweetalert.confirm('删除提醒', '确认删除所选的数据？').then(() => {
                httpRequest.post_ivatVoucherBatchDel(voucherIdList).then(res => {
                    if (res.data.success) {
                        logger.logSuccess('删除成功！');
                        $scope.queryList();
                    } else {
                        logger.logError(res.data.message);
                    }
                });
            });
            // $scope.modalSureDeleteInvoice($scope.selectedRows)
        };
        // 导入
        $scope.importExcel = function importExcel() {
            if (!$scope.isCurrentPeriod) return;
            importExcelDialog().then(() => {});
        };
        // 下载导入模板
        $scope.downFinancial = function () {
            $scope.isCollapsed = !$scope.isCollapsed;
            window.open(
                `${
                    host.etcloudIvatApp
                }dl/dlTaskService/export_IVAT_VOUCHER_COLLECT?accessToken=${localStorage.getItem(
                    'id_token'
                )}`
            );
        };
        // 导入弹窗
        function importExcelDialog() {
            return $uibModal
                .open({
                    templateUrl: 'import-excel-dialog.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        '$rootScope',
                        'items1',
                        ($scope, $uibModalInstance, $rootScope, items1) => {
                            $scope.taxPeriod = items1;
                            // 批量导入
                            let iptFile = '';
                            $scope.uploadFiles = function uploadFiles(file, errFiles) {
                                if (file == null && errFiles.length >= 1) {
                                    logger.logError(
                                        '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
                                    );
                                    return;
                                }
                                $scope.fileName = file.name;
                                iptFile = file;
                            };
                            $scope.ok = function ok() {
                                let file = iptFile;
                                if (file) {
                                    const data = {
                                        importFile: file,
                                        typeCode: 'IVAT_VOUCHER_COLLECT',
                                        taxPeriod: items1,
                                    };
                                    file.upload = Upload.upload({
                                        url: `${host.etcloudIvatApp}dl/dlTaskService/importVoucher`,
                                        data,
                                    });
                                    // 文件上传
                                    // loading动画
                                    const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                                        time: 0,
                                        skin: 'layer-loading-self',
                                        icon: 16,
                                        shade: 0.5,
                                    });
                                    file.upload.then(
                                        response => {
                                            $timeout(() => {
                                                if (!response.data.success) {
                                                    // 关闭loading
                                                    layer.close(importinglayer);
                                                    return logger.logError(
                                                        response.data.message || '上传失败'
                                                    );
                                                }
                                                file.result = response.data;
                                                const { batchNo } = file.result.value;
                                                const { sourceCount } = file.result.value;
                                                const { errorCount } = file.result.value;
                                                const { successKeyCount } = file.result.value;
                                                const { reamrk } = file.result.value;
                                                const _req = {
                                                    pageNum: 1,
                                                    pageSize: 10,
                                                    param: batchNo,
                                                };
                                                $uibModalInstance.close(_req);
                                                // 请求错误信息
                                                httpRequest
                                                    .post_getPageDlBatchInfoList(_req)
                                                    .then(res => {
                                                        // 关闭loading
                                                        layer.close(importinglayer);
                                                        // 获取导出信息详细数据
                                                        const goodsImportRes = res.data.value;
                                                        const modalData = {
                                                            // 返回给弹窗的数据
                                                            idToken: $rootScope.idToken,
                                                            params: {
                                                                batchNo,
                                                                sourceCount,
                                                                successCount:
                                                                    sourceCount - errorCount,
                                                                errorCount,
                                                                data: goodsImportRes,
                                                                successKeyCount,
                                                                reamrk,
                                                            },
                                                            isOvatBill: false,
                                                            isOvatRedBill: false,
                                                            showRelieve: true,
                                                        };
                                                        // 弹窗实例
                                                        const modalInstance = $uibModal.open({
                                                            templateUrl:
                                                                './app/outputManage/fillOpenManage/ovatBill/view/importOvatBillModalContentCtrl.html',
                                                            controller:
                                                                'importOvatBillModalContentCtrl',
                                                            backdrop: 'static',
                                                            openedClass:
                                                                'mod-modal-importexcel mod-modal mod-modal-lg',
                                                            windowClass: 'mod-modal mod-modal-lg',
                                                            bindToController: true,
                                                            resolve: {
                                                                items1() {
                                                                    return modalData;
                                                                },
                                                            },
                                                        });
                                                    });
                                            });
                                        },
                                        response => {
                                            if (response.status > 0) {
                                                // 关闭loading
                                                layer.close(importinglayer);
                                                logger.logError('上传失败 ');
                                            }
                                        },
                                        evt => {
                                            file.progress = Math.min(
                                                100,
                                                parseInt((100.0 * evt.loaded) / evt.total)
                                            );
                                            console.log(file.progress);
                                        }
                                    );
                                }
                            };
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss();
                            };
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-md',
                    resolve: {
                        items1() {
                            return $scope.queryParam.param.taxPeriod;
                        },
                    },
                })
                .result.then(
                    () => {
                        $scope.queryList();
                    },
                    () => {}
                );
        }
        function fixNumber(v) {
            if (v === null || v === '' || v === undefined) return '';
            return v.toFixed(2);
        }
        $scope.pullDownHandle = function () {
            if (!$scope.isCurrentPeriod) return;
            $scope.isCollapsed = !$scope.isCollapsed;
        };
        $scope.closeSelect = function () {
            $scope.isCollapsed = false;
        };
        const getOvatAmt = array => {
            let debitAmtCount = 0,
                creditAmtCount = 0;
            array &&
                array.forEach(item => {
                    creditAmtCount += item.creditAmt || 0;
                    debitAmtCount += item.debitAmt || 0;
                });
            return {
                voucherNumber: array.length,
                debitAmtCount: debitAmtCount.toFixed(2),
                creditAmtCount: creditAmtCount.toFixed(2),
            };
        };
        //获取会计期间
        function getAccountPeriod() {
            let date = new Date();
            let fullYeamr = date.getFullYear();
            let month = date.getMonth();
            let day = date.getDate();
            if (day < 16) {
                month = month > 9 ? month : '0' + month;
                return fullYeamr + '-' + month;
            } else {
                month += 1;
                month = month > 9 ? month : '0' + month;
                return fullYeamr + '-' + month;
            }
        }
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.voucherStatistical = $scope.copeyVoucherStatistical;
                return;
            }
            const { voucherNumber, debitAmtCount, creditAmtCount } = getOvatAmt(
                $scope.selectedRows
            );
            let result = {
                voucherNumber,
                debitAmtCount,
                creditAmtCount,
            };
            $scope.voucherStatistical = result;
        });
        async function init() {
            $scope.queryList(true);
            let res = await httpRequest.get_dictByTypeArr([
                'voucher_source',
                'voucher_account_status',
            ]);
            $scope.dic = res.data.value;
            $scope.queryParam.param.taxPeriod = getAccountPeriod();
            await $timeout(() => {
                $('#taxPeriod').datetimepicker({
                    startView: 3,
                    autoclose: true,
                    minView: 'year',
                    language: 'zh-CN',
                    format: 'yyyymm',
                    forceParse: 0,
                    pickTime: false,
                    pickerPosition: 'bottom-right',
                    initialDate: $scope.queryParam.param.taxPeriod,
                });
            }, 100);
            $scope.queryParam.param.taxPeriod = $scope.queryParam.param.taxPeriod.replace(/-/g, '');
            // 改变所属期
            $scope.$watch('queryParam.param.taxPeriod', (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    $scope.isCurrentPeriod =
                        newVal.replace(/-/, '') < currentTaxPeriod ? false : true;
                    $scope.reset();
                    $scope.queryParam.pageNum = 1;
                    $scope.totalItems = 0;
                    $scope.searchList();
                }
            });
        }
        init();
    }
}

financialListCtrl.$inject = [
    '$scope',
    'sweetalert',
    '$state',
    'httpRequest',
    'logger',
    '$uibModal',
    'initSortService',
    'Upload',
    '$timeout',
];

export default financialListCtrl;



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/financial/financialListCtrl.js